import { render, staticRenderFns } from "./DepartmentEfficiencyReport.vue?vue&type=template&id=b2354c40&scoped=true&"
import script from "./DepartmentEfficiencyReport.vue?vue&type=script&lang=js&"
export * from "./DepartmentEfficiencyReport.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentEfficiencyReport.vue?vue&type=style&index=0&id=b2354c40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2354c40",
  null
  
)

export default component.exports